import axios from 'axios';
import { setFormAxios } from 'axios-form-handler';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

setFormAxios(window.axios);
